import { useCallback, useRef } from 'react';

interface UseIntersectionObserverProps {
  onIntersect: () => void;
  enabled: boolean;
  threshold?: number;
  rootMargin?: string;
}

const useIntersectionObserver = ({ onIntersect, enabled, threshold = 0.1, rootMargin = '0px' }: UseIntersectionObserverProps) => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const onIntersectRef = useRef(onIntersect);

  // 최신 콜백 유지
  onIntersectRef.current = onIntersect;

  const elementRef = useCallback(
    (node: HTMLDivElement | null) => {
      // 기존 observer에서 이전 element unobserve
      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      // enabled가 false거나 node가 없으면 종료
      if (!node || !enabled) {
        return;
      }

      // Observer 생성 (필요시)
      if (!observerRef.current) {
        observerRef.current = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              onIntersectRef.current();
            }
          },
          { threshold, rootMargin }
        );
      }

      // 새 element 관찰 시작
      observerRef.current.observe(node);
    },
    [enabled, threshold, rootMargin]
  );

  return elementRef;
};

export default useIntersectionObserver;
